import APICall from "../utils/APICall"

export default class CardServices {
 static listCardRequests = async (page, pageLimit, search, from , to,cardStatus,cardType, deliveryType) =>{
     return await APICall(`/api/CardRequest/admin/list-card-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&cardStatus=${cardStatus}&cardType=${cardType}&deliveryType=${deliveryType}`, "GET");
 }
 static exportCardRequest = async (search, from, to,cardStatus,cardType) => {
     return await APICall(`/api/CardRequest/admin/export-card-request?search=${search}&from=${from}&to=${to}&cardStatus=${cardStatus}&cardType=${cardType}`, "GET")
 }
 static actionRequest = async (payload) => {
    return await APICall("/api/CardRequest/admin/action-card-request", "POST", payload)
 }
  static summary = async () =>{
     return await APICall(`/api/CardRequest/admin/card-request-summary`, "GET");
  }

  static listVirtualCardRequest = async (page = 1, pageLimit = 10, search = "", cardStatus = "", cardType = "", from = "", to = "") => {
    let url = `/api/VirtualCardRequest/admin/list-virtualcard-request?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (cardStatus) url = `${url}&cardStatus=${cardStatus}`;
    if (cardType) url = `${url}&cardType=${cardType}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    return await APICall(url, "GET");
  }

  static exportVirtualCardRequest = async (page = 1, pageSize = 10) => {
    return await APICall(`/api/VirtualCardRequest/admin/export-virtualcard-request?page=${page}&pageSize=${pageSize}`, "GET")
  }

  static virtualCardRequestSummary = async () => {
    return await APICall("/api/VirtualCardRequest/admin/virtualcard-request-summary", "GET")
  }
}